export default {
	"display-lg": [
		"3.5625rem",
		{ lineHeight: "1.1228070175438596", letterSpacing: "0", fontWeight: 400 },
	],
	"display-md": [
		"2.8125rem",
		{ lineHeight: "1.1555555555555554", letterSpacing: "0", fontWeight: 400 },
	],
	"display-sm": [
		"2.25rem",
		{ lineHeight: "1.2222222222222223", letterSpacing: "0", fontWeight: 400 },
	],
	"headline-lg": [
		"2rem",
		{ lineHeight: "1.25", letterSpacing: "0", fontWeight: 400 },
	],
	"headline-md": [
		"1.75rem",
		{ lineHeight: "1.2857142857142858", letterSpacing: "0", fontWeight: 400 },
	],
	"headline-sm": [
		"1.5rem",
		{ lineHeight: "1.3333333333333333", letterSpacing: "0", fontWeight: 400 },
	],
	"title-lg": [
		"1.375rem",
		{ lineHeight: "1.2727272727272727", letterSpacing: "0", fontWeight: 400 },
	],
	"title-md": [
		"1rem",
		{ lineHeight: "1.5", letterSpacing: "0.009375em", fontWeight: 500 },
	],
	"title-sm": [
		"0.875rem",
		{
			lineHeight: "1.4285714285714286",
			letterSpacing: "0.0071428571428571435em",
			fontWeight: 500,
		},
	],
	"label-lg": [
		"0.875rem",
		{
			lineHeight: "1.4285714285714286",
			letterSpacing: "0.0071428571428571435em",
			fontWeight: 500,
		},
	],
	"label-md": [
		"0.75rem",
		{
			lineHeight: "1.3333333333333333",
			letterSpacing: "0.041666666666666664em",
			fontWeight: 500,
		},
	],
	"label-sm": [
		"0.6875rem",
		{
			lineHeight: "1.6666666666666667",
			letterSpacing: "0.045454545454545456em",
			fontWeight: 500,
		},
	],
	"body-lg": [
		"1rem",
		{ lineHeight: "1.5", letterSpacing: "0.03125em", fontWeight: 400 },
	],
	"body-md": [
		"0.875rem",
		{
			lineHeight: "1.4285714285714286",
			letterSpacing: "0.017857142857142856em",
			fontWeight: 400,
		},
	],
	"body-sm": [
		"0.75rem",
		{
			lineHeight: "1.3333333333333333",
			letterSpacing: "0.03333333333333333em",
			fontWeight: 400,
		},
	],
} as const
